<template>
  <div class="mrb-16">
    <div v-if="deviceSerial && isTrueDeviceSerial" :id="videoContainerId"></div>
    <div class="emptySp" v-else>
      <img :width="width" :height="height" :src="currentEmptyImg" alt="" />
      <!--      <span class="description">暂无监控视频</span>-->
    </div>
  </div>
</template>

<script>
import EZUIKit from "ezuikit-js";
import api from "@/api/http";
// import baseEmpty from "@/components/base-empty";
import emptySp from "@/assets/images/emptyJk.png";
import emptySpEn from "@/assets/images/emptyJK-en.png";
export default {
  name: "ezviz-video",
  components: {
    // baseEmpty,
  },
  props: {
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 100,
    },
    deviceSerial: {
      type: String,
      default: "",
    },
    //是否关闭加密
    isCloseEncrypt: {
      type: Boolean,
      default: true,
    },
    //是否开启加密
    isOpenEncrypt: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      emptySp,
      emptySpEn,
      player: null,
      accessToken: null,
      videoUrl: null,
      isTrueDeviceSerial: false,
      videoContainerId: `video-container-${Math.random()
        .toString(36)
        .substr(2, 9)}`, // 生成唯一ID
    };
  },
  computed: {
    currentEmptyImg() {
      return this.$i18n.locale === "zh-CN" ? this.emptySp : this.emptySpEn;
    },
  },
  methods: {
    async init() {
      if (this.deviceSerial) {
        await this.getAccessToken();
        await this.getURL();
        if (this.isCloseEncrypt) {
          await this.closeEncrypt();
        }
        if (this.isOpenEncrypt) {
          await this.openEncrypt();
        }
        await this.initPlugin();
      }
    },
    initPlugin() {
      const player = new EZUIKit.EZUIKitPlayer({
        id: this.videoContainerId, // 使用唯一的容器ID
        accessToken: this.accessToken,
        url: this.videoUrl,
        width: this.width,
        height: this.height,
        template: "f69a9334f29a4ee4b41add6e00929c71", //自建的模板id
        handleSuccess: function () {
          if (player && player.pause) {
            player.pause();
          }
        },
      });
      this.player = player;
    },

    async getAccessToken() {
      let url = "https://open.ys7.com/api/lapp/token/get";
      let params = {
        appKey: "2fa145113855400db4bc76a621d5bd1c",
        appSecret: "33ed604b2945d87b4ac2e3bb64866c81",
      };
      await api
        .commonPost(url, params)
        .then((res) => {
          if (res.code === "200") {
            this.accessToken = res.data.accessToken;
          }
        })
        .catch(() => {});
    },

    async getURL() {
      this.isTrueDeviceSerial = false;
      this.videoUrl = null;
      let url = "https://open.ys7.com/api/lapp/v2/live/address/get";
      let params = {
        accessToken: this.accessToken,
        deviceSerial: this.deviceSerial,
      };
      await api
        .commonPost(url, params)
        .then((res) => {
          if (res.code === "200") {
            this.isTrueDeviceSerial = true;
            this.videoUrl = res.data.url;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },

    async closeEncrypt() {
      let url = "https://open.ys7.com/api/lapp/device/encrypt/off";
      let params = {
        accessToken: this.accessToken,
        deviceSerial: this.deviceSerial,
      };
      await api.commonPost(url, params);
    },
    async openEncrypt() {
      let url = "https://open.ys7.com/api/lapp/device/encrypt/on";
      let params = {
        accessToken: this.accessToken,
        deviceSerial: this.deviceSerial,
      };
      await api.commonPost(url, params);
    },
    openPlayer() {
      this.player.play();
    },
    stopPlayer() {
      this.player ? this.player.stop() : "";
    },
  },
  watch: {
    deviceSerial: {
      handler() {
        this.videoUrl = null;
        this.stopPlayer();
        setTimeout(() => {
          this.init();
        }, 500);
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  beforeDestroy() {
    this.player && this.player.stop(); //销毁并停止直播视频
  },
};
</script>

<style lang="less" scoped>
.emptySp {
  position: relative;
  display: inline-block;
}
.description {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 22px;
  text-align: center;
  font-style: normal;
}
</style>
